import BaseModifierBehavior from './BaseModifierBehavior';
import CardStateHelper from '../CardStateHelper';
import { IGameState } from 'State/Game/IGameState';

export default abstract class TimerModifierBehavior extends BaseModifierBehavior {
    protected setTimer(state: IGameState, timer: number): IGameState {
        let cardsState = this.updateModifier(state.levelState.cardsState, this.cardID, {
            properties: {
                ...this.modifier.properties,
                timer,
            },
        });
        state = CardStateHelper.updateGameState(state, cardsState)
        return this.onTimerChanged(state, timer);
    }

    protected isTimerFinished(state: IGameState): boolean {
        return CardStateHelper.modifierHasCompletedTimer(state, this.cardID, this.modifier.type);
    }

    protected onTimerChanged(state: IGameState, timer: number): IGameState {
        return state;
    }
}
